import React from 'react';
import { ELDA_URL } from '../../../variables';
import Terms from '../../components/common/Terms';

const SparqlQueryPage = () => {
    return (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <iframe src={`${ELDA_URL}/sparql`} title="SparqlQuery" style={{ width: '100%', height: 'calc(100vh - 95px)' }} />
            <Terms />
        </div>
    );
};

export default SparqlQueryPage;
